import { Asset } from '../../common/model/Assets';
import DgProject from './DgProject';
export class DigitalGrowMetric {
}
export default class DigitalGrow {
    static fromPartial(partial) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        const digitalGrow = new DigitalGrow();
        const translation = (_a = partial.translations) === null || _a === void 0 ? void 0 : _a.pop();
        digitalGrow.title = (_b = translation === null || translation === void 0 ? void 0 : translation.title) !== null && _b !== void 0 ? _b : '';
        digitalGrow.formation_title = (_c = translation === null || translation === void 0 ? void 0 : translation.formation_title) !== null && _c !== void 0 ? _c : '';
        digitalGrow.assistance_title = (_d = translation === null || translation === void 0 ? void 0 : translation.assistance_title) !== null && _d !== void 0 ? _d : '';
        const formation_metrics = partial.formation_metrics;
        const assistance_metrics = partial.assistance_metrics;
        const projects = partial.projects;
        const projects_image = translation === null || translation === void 0 ? void 0 : translation.map_image;
        digitalGrow.formation_metrics = new Array();
        digitalGrow.assistance_metrics = new Array();
        digitalGrow.projects = new Array();
        if (formation_metrics) {
            for (const metric of formation_metrics) {
                const formationMetric = new DigitalGrowMetric();
                const translation = (_f = (_e = metric === null || metric === void 0 ? void 0 : metric.digital_grow_metrics_id) === null || _e === void 0 ? void 0 : _e.translations) === null || _f === void 0 ? void 0 : _f.pop();
                formationMetric.value = (_h = (_g = metric === null || metric === void 0 ? void 0 : metric.digital_grow_metrics_id) === null || _g === void 0 ? void 0 : _g.value) !== null && _h !== void 0 ? _h : '';
                formationMetric.name = (_j = translation === null || translation === void 0 ? void 0 : translation.name) !== null && _j !== void 0 ? _j : '';
                formationMetric.unit = (_k = translation === null || translation === void 0 ? void 0 : translation.unit) !== null && _k !== void 0 ? _k : '';
                digitalGrow.formation_metrics.push(formationMetric);
            }
        }
        if (assistance_metrics) {
            for (const metric of assistance_metrics) {
                const assistanceMetric = new DigitalGrowMetric();
                const translation = (_m = (_l = metric === null || metric === void 0 ? void 0 : metric.digital_grow_metrics_id) === null || _l === void 0 ? void 0 : _l.translations) === null || _m === void 0 ? void 0 : _m.pop();
                assistanceMetric.value = (_p = (_o = metric === null || metric === void 0 ? void 0 : metric.digital_grow_metrics_id) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '';
                assistanceMetric.name = (_q = translation === null || translation === void 0 ? void 0 : translation.name) !== null && _q !== void 0 ? _q : '';
                assistanceMetric.unit = (_r = translation === null || translation === void 0 ? void 0 : translation.unit) !== null && _r !== void 0 ? _r : '';
                digitalGrow.assistance_metrics.push(assistanceMetric);
            }
        }
        if (projects) {
            for (const project of projects) {
                if (project === null || project === void 0 ? void 0 : project.project_id) {
                    const dgProject = DgProject.fromPartial(project.project_id);
                    digitalGrow.projects.push(dgProject);
                }
            }
        }
        if (projects_image) {
            digitalGrow.map_image = new Asset(projects_image);
        }
        return digitalGrow;
    }
}
